import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { TabsContent } from '@/components/ui/tabs';

export default function ContactTab({ formData, setFormData, formErrors, t }) {
  return (
    <TabsContent value="contact" className="mt-3 space-y-3 h-[480px] overflow-y-auto pe-1">
      <div className="bg-white rounded-lg border border-[#C4BFF0] p-3 space-y-2">
        <p className="text-xs font-semibold text-[#655dc6]/70 tracking-wide">{t('contact_preferences')}</p>
        <div className="grid grid-cols-2 gap-3">
          <div className="space-y-1">
            <Label className="text-xs text-start block flex items-center gap-1.5">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="#25D366"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
              {t('whatsapp_number')}
            </Label>
            <div className="flex gap-1 items-center" dir="ltr">
              <span className="text-sm font-medium text-[#655dc6] bg-[#E8E6F5] px-3 py-2 rounded-md border border-[#C4BFF0] shrink-0">966+</span>
              <Input
                dir="ltr"
                className={`text-left flex-1 ${formErrors.phone ? 'border-red-500' : ''}`}
                value={formData.phone}
                onChange={(e) => {
                  const v = e.target.value.replace(/[^0-9]/g, '');
                  if (v.length <= 9) setFormData(prev => ({ ...prev, phone: v }));
                }}
                placeholder="5XXXXXXXX"
                data-testid="input-phone"
              />
            </div>
          </div>
          <div className="space-y-1">
            <Label className="text-xs text-start block">{t('birth_date')}</Label>
            <Input type="date" value={formData.birth_date} onChange={(e) => setFormData(prev => ({ ...prev, birth_date: e.target.value }))} data-testid="input-birth-date" />
          </div>
          <div className="space-y-1">
            <Label className="text-xs text-start block">{t('notification_language')}</Label>
            <div className="flex gap-2 mt-1">
              <Button
                type="button"
                variant={formData.notification_language === 'ar' ? 'default' : 'outline'}
                size="sm"
                className={formData.notification_language === 'ar' ? 'bg-[#655dc6] hover:bg-[#544cb0] flex-1 h-9' : 'border-[#655dc6] text-[#655dc6] hover:bg-[#E8E6F5] flex-1 h-9'}
                onClick={() => setFormData(prev => ({ ...prev, notification_language: 'ar' }))}
                data-testid="lang-ar-btn"
              >العربية</Button>
              <Button
                type="button"
                variant={formData.notification_language === 'en' ? 'default' : 'outline'}
                size="sm"
                className={formData.notification_language === 'en' ? 'bg-[#655dc6] hover:bg-[#544cb0] flex-1 h-9' : 'border-[#655dc6] text-[#655dc6] hover:bg-[#E8E6F5] flex-1 h-9'}
                onClick={() => setFormData(prev => ({ ...prev, notification_language: 'en' }))}
                data-testid="lang-en-btn"
              >English</Button>
            </div>
          </div>
        </div>
      </div>
    </TabsContent>
  );
}
